import React, { useState } from 'react';
import {Button, Modal, Spinner} from "react-bootstrap";
import { ElectricityAgreementRenewalPlansService } from '../ElectricityAgreementRenewalPans.service';
import { toast } from 'react-toastify';

interface CancelElectricityAgreementRenewalPlanConfirmModalProps {
    handleConfirmSubmit: () => void;
    handleConfirmReject: () => void;
    initializeRequests: (isInitial: boolean) => Promise<void>
    renewalAgreementId: number;
}

export function CancelElectricityAgreementRenewalPlanConfirmModal(props: CancelElectricityAgreementRenewalPlanConfirmModalProps) {
    const [isLoading, setIsLoading] = useState(false);

    const confirmSubmit = async () => {
        try {
            setIsLoading(true);
            await ElectricityAgreementRenewalPlansService.cancelAgreementRenewalPlan(props.renewalAgreementId);
            await props.initializeRequests(false);
            props.handleConfirmSubmit();
        } catch(e) {
            console.error(e);
            toast.error("Pikendusplaani tühistamine ebaõnnestus")
        } finally {
            setIsLoading(false);
        }
    };

    const rejectSubmit = () => {
        props.handleConfirmReject();
    };

    return (
        <>
            <Modal
                show={true}
                size={"sm"}
                centered
            >
                <Modal.Header>
                    <Modal.Title>
                        Kinnita muudatused
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <span>Kas oled kindel, et soovid pikendusplaani tühistada?</span>
                </Modal.Body>
                <Modal.Footer className="d-flex flex-row align-items-end justify-content-around flex-wrap mb-1">
                    <Button variant="info"
                            onClick={() => rejectSubmit()}
                            type="button"
                            disabled={isLoading}
                            className={"d-flex align-items-center"}>
                        <span className='px-2'>Tühista</span>
                    </Button>
                    <Button variant="primary"
                            onClick={confirmSubmit}
                            type="button"
                            className="d-flex align-items-center"
                    >
                        {
                            isLoading ? (
                                <Spinner size={"sm"} animation={"border"}/>
                            ) : (
                                <span className='px-2'>Salvesta</span>
                            )
                        }
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}